const INSPECTION_ACT_BASE_URL = 'https://act1.qlean.ru/'

export const INSPECTION_ACT_PRODUCT_SLUGS = [
  'cleaning_flat_renovation',
  'cleaning_flat_deep',
  'hourly_deep_cleaning',
  'drycleaning_furniture',
  'ya_drycleaning_furniture',
]

export const isInspectionActProduct = (productSlug?: string): boolean =>
  Boolean(productSlug && INSPECTION_ACT_PRODUCT_SLUGS.includes(productSlug))

export const getInspectionActUrl = (orderId: string): string =>
  `${INSPECTION_ACT_BASE_URL}?uid=${encodeURIComponent(orderId)}`
